import { useEffect, useState } from 'react';
import Tabs from './components/Tabs';
import { useLang } from '@/i18n';

export enum PageNavType {
    Benefit = 'Benefit',
    What = 'What',
    Why = 'Why',
    FAQ = 'FAQ',
}

export default function TheComp() {
    const { t } = useLang('theProduct.PageNav');
    const listA = [
        {
            href: PageNavType.Benefit,
            title: t('title1'),
        },
        {
            href: PageNavType.What,
            title: t('title2'),
        },
        {
            href: PageNavType.Why,
            title: t('title3'),
        },
        {
            href: PageNavType.FAQ,
            title: t('title4'),
        },
    ];

    const [height, setHeight] = useState(0);
    useEffect(() => {
        const header = document.querySelector('#global-nav-product') as HTMLElement;
        if (header) {
            const resize = new ResizeObserver((entries) => {
                entries.forEach((entry) => {
                    const { height } = entry.contentRect;
                    setHeight(height);
                });
            });
            resize.observe(header);
            return () => resize.disconnect();
        }
    }, []);

    return <Tabs list={listA} sticky stickyHeight={height} />;
}
